import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";

const SettlementCard = ({ item }) => {
  const { settlement } = item;

  const formatDate = (time) =>
    time
      ? new DateObject({
          date: time * 1000,
          calendar: persian,
        }).format("YYYY/MM/DD")
      : "-";

  return (
    <div className="rounded-2xl border border-neutral-20 bg-primary-10 shadow-sm p-4 flex flex-col gap-4 hover:shadow-md transition-shadow">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <p className="text-xs text-neutral-500">مبلغ تسویه</p>
          <p className="font-semibold text-neutral-900">{`${settlement.amount.toLocaleString()} ریال`} </p>
        </div>

        <span
          className={`rounded-full px-4 py-1 text-xs font-semibold ${
            settlement.paid ? "bg-success-10 text-success-90" : "bg-yellow-100 text-yellow-700"
          }`}
        >
          {settlement.paid ? "پرداخت شده" : "در انتظار پرداخت"}
        </span>
      </div>

      <hr className="border-neutral-20" />

      {/* Body */}
      <div className="space-y-3 text-sm">
        <InfoRow title="تاریخ درخواست" value={formatDate(settlement.creation_time)} />

        <InfoRow title="تاریخ پرداخت" value={formatDate(settlement.payment_time)} />

        <InfoRow title="صاحب حساب" value={settlement.owner || "-"} />

        <InfoRow title="شماره شبا" value={settlement.iban || "-"} />

        <InfoRow title="کد رهگیری بانکی" value={settlement.tracking_number || "-"} />
      </div>
    </div>
  );
};

const InfoRow = ({ title, value }) => (
  <div className="flex justify-between items-center gap-4">
    <span className="text-neutral-500 text-xs">{title}</span>

    <span className="text-neutral-900 font-medium text-left break-all">{value}</span>
  </div>
);

export default SettlementCard;
